module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1527-c0de1b0bd528e3f7527d3bbe4e6be6e1.png";